import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const Users = Loadable(lazy(() => import("./Users")));
const CreateUser = Loadable(lazy(() => import("../users/CreateUser")));
const ChangeUserPassword = Loadable(
  lazy(() => import("../users/ChangeUserPassword"))
);

const usersRoutes = [
  {
    path: "/users",
    element: <Users />,
    auth: authRoles.superUser,
  },
  {
    path: "/user/:userId/change-password",
    element: <ChangeUserPassword />,
    auth: authRoles.superUser,
  },
  {
    path: "/users/new",
    element: <CreateUser />,
    auth: authRoles.superUser,
  },
];

export default usersRoutes;
